import BadRequestError from '../errors/BadRequestError';
import ForbiddenError from '../errors/ForbiddenError';
import HTTPError from '../errors/HTTPError';
import InternalServerError from '../errors/InternalServerError';
import NotFoundError from '../errors/NotFoundError';
import ServiceUnavailableError from '../errors/ServiceUnavailableError';
import UnauthorizedError from '../errors/UnauthorizedError';
import UnprocessableEntityError from '../errors/UnprocessableEntityError';
import TooManyRequestsError from '../errors/TooManyRequestsError';
var errorsForStatus = {
  400: BadRequestError,
  401: UnauthorizedError,
  403: ForbiddenError,
  404: NotFoundError,
  422: UnprocessableEntityError,
  429: TooManyRequestsError,
  500: InternalServerError,
  503: ServiceUnavailableError
};
var SafariSyntaxException = process.env.IS_BROWSER ? DOMException : SyntaxError;
/**
 * Throw custom exception based on API response
 * Note: parsing wrong JSON in Safari throws DOMException error instead of SyntaxError
 *
 * @param  {Object} response - API response
 * @return {Promise} - promise
 */

export default function throwOnError(response) {
  if (response.ok) return response;
  var ErrorClass = errorsForStatus[response.status] || HTTPError;
  return Promise.resolve(response.json()).then(function (body) {
    return {
      response: response,
      body: body
    };
  }).catch(SafariSyntaxException, function () {
    return {
      response: response,
      body: {}
    };
  }).catch(SyntaxError, function () {
    return {
      response: response,
      body: {}
    };
  }).then(function (result) {
    throw new ErrorClass(result);
  });
}